export const inputContainerStyles =
   '!border-none !shadow-none !outline-none !p-0 rounded-none flex-1 min-w-0'

export const inputStyles = 'geo-location min-w-0 !bg-base-white'

export const coordinateInputContainerStyles =
   'rounded-xl border flex-col gap-3 flex flex-1 min-w-0 p-2'

export const inputBorderStyles =
   'border-gray-300 focus-within:border-primary-300 focus-within:ring-primary-100 focus-within:ring-4'
